import angular from 'angular';

/**
 * @memberOf cms.input.checkbox
 * @property {string}  scope.title Input title and/or placeholder
 * @property {boolean} scope.model Input value reference
 */
let cmsInputCheckbox = {
    bindings: {
        model: '=',
        label: '@',
        helper: '@',
        aclShow: '<?',
        aclDisable: '<?',
        disabled: '<',
        changed: '&',
        labelSize: '@',
        inputSize: '@',
        position: '@',
        validator: '<'
    },
    template: require('./checkbox.html'),
    controller: function ($scope) {
        this.$onInit = () => {
            $scope.validatorErrors = this.validator;
        };

        this.$onChanges = () => {
            $scope.validatorErrors = this.validator;
        };
    }
};

/**
 * Checkbox control
 * @namespace cms.input.checkbox
 */
export default angular.module('cms.input.checkbox', []).component('cmsInputCheckbox', cmsInputCheckbox).name;




// WEBPACK FOOTER //
// ./src/cmsCore/Controls/ChckboxControl/CmsInputCheckbox.js